/**
 * Where the Automations screens live. Plain TypeScript rather than inline in the pages because
 * `jest.config.ts` only matches `.tsx` tests inside `src/ui`, so path logic in JSX cannot be covered.
 */

import { z } from "zod";

export const AUTOMATIONS_BASE_PATH = "/settings/automations";

/** The id segment the builder route reads as "create". */
export const NEW_AUTOMATION_SEGMENT = "new";

/** Query parameter that opens the builder at the Sales Order on-save step with a template chosen. */
export const AUTOMATION_TEMPLATE_PARAM = "templateId";

const automationIdSchema = z.string().uuid();

/** Whether a route segment can name an automation at all; the server reads only uuids, so no read is made for any other. */
export const isAutomationId = (value: string): boolean => automationIdSchema.safeParse(value).success;

export const automationListPath = (): string => AUTOMATIONS_BASE_PATH;

export const automationEditorPath = (automationId: string): string => `${AUTOMATIONS_BASE_PATH}/${automationId}`;

export const newAutomationPath = (): string => `${AUTOMATIONS_BASE_PATH}/${NEW_AUTOMATION_SEGMENT}`;

/** "Add Automation" on an Order Item Template: the builder at the on-save step, that template preselected. */
export const newAutomationForTemplatePath = (templateId: string): string =>
  `${newAutomationPath()}?${AUTOMATION_TEMPLATE_PARAM}=${encodeURIComponent(templateId)}`;
